import type { DecisionAidPlacement } from '@frontend/components/elements/DecisionAid';
import { EpisodeCategory, ServiceType, UserPreferenceSettingName } from '@common/enums';
import type { IService } from '../home/newProcess/newProcessInterfaces';
import { GgzConsultationDecisionAidSteps } from './GgzConsultationDecisionAidSteps';

export function getDecisionAidSteps(
    episodeCategory: EpisodeCategory | undefined,
    serviceType: ServiceType,
    services: IService[],
    placement?: DecisionAidPlacement
) {
    if (episodeCategory === EpisodeCategory.mentalHealth && serviceType === ServiceType.consultation) {
        return GgzConsultationDecisionAidSteps(services, placement);
    }

    return [];
}

export function getUserPreferenceSettingName(episodeCategory: EpisodeCategory | undefined, serviceType: ServiceType) {
    if (episodeCategory === EpisodeCategory.mentalHealth && serviceType === ServiceType.consultation) {
        return UserPreferenceSettingName.ggzConsultDecisionAidDefaultClosed;
    }

    return undefined;
}
